// src/components/ScrollUpButton/ScrollUpButton.jsx

// Vanha scroll-up -nappi disabloitu kokonaan.
// Pidetään komponentti olemassa, jotta mahdolliset importit eivät riko buildia.
export default function ScrollUpButton() {
  return null;
}
